<template>
  <div >
    <div class='s_flex_bian_c m-b-10' v-for="(value,index) in links " :key="index" >
      <span>{{value.name}}</span>
       <a-button type="primary" ghost @click="choose(value.link)">
          选择
       </a-button>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
export default {
name:"selectLink",
setup(pros,{emit}){
  const state= reactive({
    links:[
      {
        name:'商品列表',
        link:"/pages/goods_list/goods_list"
      },
       {
        name:'新品上架',
        link:"/pages/good_new/good_new"
      },
       {
        name:'商品分类',
        link:"/pages/goods_cate/goods_cate"
      },
       {
        name:'直播列表',
        link:"/pages/liveList/liveList"
      },
      {
        name:'个人中心',
        link:"/pages/user/user"
      } ,{
        name:'好物推荐',
        link:"/pages/good_recommend/good_recommend"
      }
      ,{
        name:'限时秒杀',
        link:"/pages/good_seckill/good_seckill"
      } ,{
        name:'好物榜',
        link:"/pages/good_thing/good_thing"
      }
    ]
  })
  const choose=(data)=>{
      emit('select',data)
  }
  return{
    ...toRefs(state),
    choose
  }
}
}
</script>
